<i class="pi pi-question-circle" 
    [pTooltip]="tooltipContent" 
    [tooltipPosition]="position"
    [style]="{'cursor': 'pointer'}">
</i>
<ng-template #tooltipContent>
    {{text}}
</ng-template>